(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.customer.show.project.aiBi', {
      url: '/ai-bi',
      component: 'aiBi',
      authenticated: true,
      resolve: {
        module: [
          '$ocLazyLoad',
          function ($ocLazyLoad) {
            return $ocLazyLoad.load([window.assetsPath + '/js/app/ai-bi.module.min.js']);
          },
        ],
      },
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.AiBi" | translate}}',
      },
    });
  }
})();
